const DIVISIONS: Array<{ amount: number; unit: Intl.RelativeTimeFormatUnit }> = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.345_24, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' }
]

/**
 * Relative-time string ("22 minutes ago" / "il y a 22 minutes") driven entirely by
 * Intl.RelativeTimeFormat rather than moment's global locale — mirrors the pattern in
 * PainterScheduleView/dateUtils.ts: moment's locale data depends on the right
 * `moment/locale/*` file being registered on the exact same bundled moment instance doing the
 * formatting, which isn't reliable across packages and silently falls back to English on any
 * mismatch. Intl draws on the browser's built-in ICU data, so it can't silently fall back this way.
 */
export function formatRelativeTime(timestamp: number, lang: string): string {
  let duration = (timestamp - Date.now()) / 1000

  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return new Intl.RelativeTimeFormat(lang, { numeric: 'auto' }).format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }

  return ''
}
